import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

/** The named type-scale steps from index.css (`text-metric`, …) are font sizes, not colors. */
const twMerge = extendTailwindMerge({
  extend: { theme: { text: ["display", "display-sm", "section", "page-title", "metric", "card-title"] } },
});

/** Merge Tailwind class names, resolving conflicts (shadcn convention). */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
